import { render, staticRenderFns } from "./SeferTorahPublicProvider.vue?vue&type=template&id=c4404aa2&"
import script from "./SeferTorahPublicProvider.vue?vue&type=script&lang=js&"
export * from "./SeferTorahPublicProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports